module.exports = __webpack_public_path__ + "static/gribbengroup-e6e42db08f81b01b2bb805c213e6c291.png";